import request from '@/utils/request'

let requestAuth = null

/**
 * @param {Object} data
 * @returns {access_token: string, refresh_token: string, expires_in: number}
 */
export async function postAuthLogin(data) {
  if (requestAuth) return await requestAuth

  try {
    requestAuth = request({
      url: `/api/oauth/token/cookie`,
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: new URLSearchParams(
        Object.entries(data).filter(([, value]) => value != null)
      ),
    })
    return await requestAuth
  } catch (error) {
    console.error(error)
    throw error
  } finally {
    requestAuth = null
  }
}

export function postAuthPhone(data) {
  return request({
    url: `/api/oauth/code_request`,
    method: 'post',
    data,
  })
}

export function postAuthLogout() {
  return request({
    url: `/api/oauth/token/logout`,
    method: 'post',
  })
}
